import { useQuery } from "@tanstack/react-query";
import type { SearchContext } from "@/features/search/types";
import { useTRPC } from "@/trpc/client";

interface UseSearchParams {
  q?: string;
  context: SearchContext;
  studySetId?: string;
  subject?: string;
  enabled?: boolean;
}

export function useSearch({
  q,
  context,
  studySetId,
  subject,
  enabled = true,
}: UseSearchParams) {
  const trpc = useTRPC();
  return useQuery(
    trpc.search.preview.queryOptions(
      { q, context, studySetId, subject },
      {
        enabled: enabled && !!q,
      },
    ),
  );
}
